enum TagContentType {
  customInsight = 'customInsight',
  entity = 'entity',
  rule = 'rule',
}

const allTagContentTypes = [
  TagContentType.customInsight,
  TagContentType.entity,
  TagContentType.rule,
];
const sourceContentTypesMap = {
  insight: allTagContentTypes,
  entity: [TagContentType.entity],
  signal: allTagContentTypes,
  rules: [TagContentType.rule],
  customInsight: [TagContentType.customInsight],
};
const supportedSources = Object.keys(sourceContentTypesMap);

export const getContentTypes = (source?: string) =>
  source ? sourceContentTypesMap[source] : undefined;

export const isSupportedSource = (source: string) =>
  supportedSources.includes(source);
